(() => {
  const toggleDescription = (button) => {
    const id = button.getAttribute('aria-controls');
    const description = id ? document.getElementById(id) : null;
    if (!description) return;

    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    description.classList.toggle('expanded', !isExpanded);
    button.setAttribute('aria-expanded', String(!isExpanded));
    button.textContent = isExpanded
      ? button.dataset.labelCollapsed || 'Read More'
      : button.dataset.labelExpanded || 'Show Less';
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-collection-description-toggle]');
    if (button) toggleDescription(button);
  });
})();
